import { Card, Statistic, Row, Col } from "antd";
import React from "react";
import styles from "./StatsCard.module.css";

function StatsCard({ title, image, value, unit }: { title?: string; image?: any; value?: string; unit?: string }) {
    return (
        <Card className={styles.card}>
            <p>{title}</p>
            <Row align="bottom">
                <Col span={3} className={styles.icon}>
                    {image}
                </Col>
                <Col span={21}>
                    <Row align="bottom" justify="end">
                        <Statistic className={styles.statistic} suffix={unit} value={value} />
                    </Row>
                </Col>
            </Row>
        </Card>
    );
}

export default StatsCard;
